import {isVaild} from "@/utils/validate";

function getNavigationKey(identification) {
    return `navigation_${identification}`
}

export function setNavigationItemWithObj(key, value) {
    // console.log(`setNavigationItemWithObj ${JSON.stringify(value)}`)
    return setNavigationItem(key, JSON.stringify(value))
}

function setNavigationItem(key, value) {
    return sessionStorage.setItem(getNavigationKey(key), value)
}

function getNavigationItem(key) {
    return sessionStorage.getItem(getNavigationKey(key))
}

export function getNavigationItemObj(key) {
    // console.log(`getNavigationItemObj ${getNavigationItem(key)}`)
    let res = JSON.parse(getNavigationItem(key))
    if (isVaild(res)) {
        return res
    } else {
        return {}
    }
}

export function removeNavigationItem(key) {
    return sessionStorage.removeItem(getNavigationKey(key))
}